<template>
 
<div style="margin: 5px;">
    <InputGroup>
     
    <!--   <Dropdown v-if="options" v-model="value" 
      filter 
           :options="options" 
            optionLabel="Name"
            optionValue="Code"   
            /> -->


<Dropdown 
    filter
    :filterFields="['Name', 'Code']" 
    v-model="value" 
    :options="options" 
    optionValue="Code" 
    placeholder="Select an Item">
    
    <!-- Customizes the selected value display in the input box -->
    <template #value="slotProps">
        <div v-if="slotProps.value">
           <span v-if="IsRedColor" style="color: red;"> {{getSelectedItemLabel(slotProps.value) }}</span>
           <span v-else> {{getSelectedItemLabel(slotProps.value) }}</span>
        </div>
        <span v-else>{{ slotProps.placeholder }}</span>
    </template>

    <!-- Customizes each row in the dropdown list -->
    <template #option="slotProps">
        <div>
            <span>({{slotProps.option.Code}}){{ slotProps.option.Name }}</span>
           
        </div>
    </template>
</Dropdown>


</InputGroup>
</div>


     
</template>  
<script>

import SupervisorApplyService from "../../service/SupervisorApplyService";
export default {
    props: ['modelValue',  'disabled','required','IsRedColor'],
    emits:["update:modelValue","update:error"],
    components: {

    },
    data() {
        return {
            SupervisorApplyService: null,
            value: null,
            options: []
        }
    },
    created() {
        this.SupervisorApplyService=new SupervisorApplyService();
        this.value=this.modelValue;
        this.GetCountry();
        
    },
    mounted(){
        this.value = (this.modelValue);
        this.$emit("update:error", this.isError);
      },
      computed:{
        isError(){
            return  !this.value;
        },
     },
    watch: {
            /*  modelValue: function (newVal, oldVal) {
              // watch it
              console.log("Prop changed: ", newVal, " | was: ", oldVal);
              this.value = this.modelValue
            }, */
            value: function (newVal) {
              // watch it
              //console.log("Prop changed: ", newVal, " | was: ", oldVal);
              this.$emit("update:modelValue", newVal );
              this.$emit("update:error", this.isError);
            },
          },
 

          methods: {

            getSelectedItemLabel(id)  {
                const found = this.options.find(item => item.Code === id);
                return found ? `(${found.Code})${found.Name}` : '';
            },

            GetCountry(){
                let self=this;
                this.SupervisorApplyService.GetCountry().then((data) => {
                    
                        self.options=data;
                     
                })


            },
        }
}
</script>
  
  